export const setPlan = 'setPlan'
export const setPlans = 'setPlans'
export const updatePlan = 'updatePlan'
export const setPlanAfterUpdate = 'setPlanAfterUpdate'
export const clearPlans = 'clearPlans'
export const setFilterPlan = 'setFilterPlan'
export const clearFilterPlan = 'clearFilterPlan'
export const clearFilterPlans = 'clearFilterPlans'



// WEBPACK FOOTER //
// ./src/app/pages/plans/vuex/mutations-types.js